import { render, staticRenderFns } from "./AssignmentDetailCard.vue?vue&type=template&id=509708c8"
import script from "./AssignmentDetailCard.vue?vue&type=script&lang=js"
export * from "./AssignmentDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports